export const initialState = {
  questionActions: []
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'onActionDetailsPropertyChanged':
      return onActionDetailsPropertyChanged(state, action);
    case 'OnQuestionActionAdded':
      return onQuestionActionAdded(state, action);
    case 'OnQuestionActionExpanded':
      return onQuestionActionExpanded(state, action);
    case 'OnQuestionActionSaved':
      return onQuestionActionSaved(state, action);
    case 'OnQuestionActionDeleted':
      return OnQuestionActionDeleted(state, action);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { data } = action;
  return {
    ...state,
    questionActions: data.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function onActionDetailsPropertyChanged(state, action) {
  const { propName, propValue, index } = action;
  return {
    ...state,
    questionActions: Object.assign([...state.questionActions], {
      [index]: {
        ...state.questionActions[index],
        [propName]: propValue,
        changed: true
      }
    })
  };
}

const onQuestionActionExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    questionActions: Object.assign([...state.questionActions], {
      [index]: {
        ...state.questionActions[index],
        isExpanded: isExpanded
      }
    })
  };
};

function onQuestionActionSaved(state, action) {
  let index = 0;
  index = state?.questionActions.findIndex(x => x.questionActionId === action.data.id);
  if (index === -1) index = action.data.idx;
  return {
    ...state,
    questionActions: Object.assign([...state.questionActions], {
      [index]: {
        ...state.questionActions[index],
        questionActionId: action.data.id,
        changed: false,
        isExpanded: true
      }
    })
  };
}

function OnQuestionActionDeleted(state, action) {
  const { index } = action;
  const newQuestionActions = Object.assign([...state.questionActions]);
  newQuestionActions.splice(index, 1);
  return {
    ...state,
    questionActions: newQuestionActions
  };
}

function onQuestionActionAdded(state, action) {
  const { index, questionnaireId } = action;
  const questionAction = {
    questionActionId: null,
    siteId: 0,
    formula: '',
    questionActionTypeId: null,
    questionnaireId,
    changed: true,
    isExpanded: true
  };
  const newQuestionActions = Object.assign([...state.questionActions]);
  if (index) newQuestionActions.splice(index, 0, { ...questionAction, changed: true });
  else newQuestionActions.push({ ...questionAction, changed: true });
  return {
    ...state,
    questionActions: newQuestionActions
  };
}
